import React, { useEffect } from "react";
import HomeReviews from "../../components/homepage-components/HomeReviews";
import Faq from "../../components/universal-components/Faq";
import Hero from "../../components/Hero";
import Intro from "../../components/Intro";
import ContentLeft from "../../components/ContentLeft";
import ContentRight from "../../components/ContentRight";
import CallToAction from "../../components/CallToAction";
import { insuranceContent } from "../../page-content/commercial-content/insuranceContent";

const InsuranceContracts = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Hero data={insuranceContent} />
      <Intro data={insuranceContent} />
      <ContentLeft data={insuranceContent} />
      <ContentRight data={insuranceContent} />
      <CallToAction data={insuranceContent} />
      <HomeReviews />
      <Faq />
    </>
  );
};

export default InsuranceContracts;
